// extracted by mini-css-extract-plugin
export default {"label":"Ingenico_label__aRHRD","saved_payment_method":"Ingenico_saved_payment_method__T2hMy","button_new_payment_method":"Ingenico_button_new_payment_method__syvJ5"};